module.exports = __webpack_public_path__ + "media/assets/Lock-27a08363e034b4771960f17edf5bfa83.svg";